import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SendBtn from "../../utils/Register/send_btn";
import conversion from "../../assets/wito.png";
import backImage from "../../assets/fondo.png";
import MenuField from "../../utils/Register/menu_field";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const CategoryUser = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const token = useSelector((state) => state.user.token);
  const [userId, setUserId] = useState("");

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
    }
  }, [token]);

  const options = [
    {
      value: "organizacion",
      label: "Organización",
      tooltip: "Puedes crear equipos, torneos, jugadores, etc",
    },
    { value: "dt", label: "DT", tooltip: "Encargado" },
    {
      value: "jugador",
      label: "Jugador",
      tooltip: "Manejarás tu perfil como jugador",
    },
    {
      value: "espectador",
      label: "Espectador",
      tooltip: "Podrás seguir a tus jugadores y eventos",
    },
  ];

  const routes = {
    organizacion: "/organization-profile",
    dt: "/",
    jugador: "/player-profile",
    espectador: "/",
  };

  const handleCategory = async (e) => {
    e.preventDefault();

    if (!selectedOption) {
      setError("Por favor, selecciona una categoría.");
      return;
    }

    try {
      const response = await fetch(
        `https://server-postgre.vercel.app/api/users/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_type: selectedOption }),
        }
      );

      if (!response.ok) {
        throw new Error("No se pudo actualizar el tipo de usuario.");
      }

      navigate(routes[selectedOption] || "/");
    } catch (error) {
      setError("Error al establecer la categoría: " + error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        {/* Encabezado */}
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Ya falta</h1>
          <p className="text-lg mt-2">Poco</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        {/* Formulario */}
        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">¿Eres...?</h2>
          <form onSubmit={handleCategory}>
            <MenuField
              label=""
              placeholder="Selecciona una opción"
              options={options}
              selectedOption={selectedOption}
              onOptionSelect={setSelectedOption}
            />
            <div className="mb-40" />
            <SendBtn
              label="Siguiente"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            {error && <p className="text-red-500">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default CategoryUser;
